import { useState } from "react";
import { listAllProjectOfCenter } from "../../../../Service/ApiService";
import AuthenticationService from "../../../../Service/AuthenticationService";
import { useSnackbar } from "notistack";
import AdminDataGrid from "../AdminDataGrid";
import { useTranslation } from "react-i18next";

const ProjectDataGrid = (props: any) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const listOfRequest = async () => {
    return listAllProjectOfCenter(
      AuthenticationService.company,
      AuthenticationService.email,
      AuthenticationService.token
    )
      .then((newData: any) => {
        return newData;
      })
      .catch((error) => {
        enqueueSnackbar(t("error.errorHasOccured"), {
          variant: "error",
        });
        console.error(error);
      });
  };

  const [origin, setOrigin] = useState("");

  const selectRequestData = (newRequestData: any) => {
    setOrigin(
      newRequestData.state === "processing"
        ? "processingProject"
        : "stateDefinedProject"
    );
  };
  const updateOrigin = (newOrigin: string) => {
    setOrigin(newOrigin);
  };

  return (
    <AdminDataGrid
      listOfRequest={listOfRequest}
      selectRequestData={selectRequestData}
      origin="Project"
      originSummmary={origin}
      updateOrigin={updateOrigin}
      updateNotification={props.updateNotification}
    />
  );
};

export default ProjectDataGrid;
